export default __webpack_public_path__ + "static/media/metal.0e3f026a.png";